<script>
import DataTableRequestColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableRequestColumn.vue';
import UsersRequest from '@/app/users/UsersRequest';

export default {
  name: 'ClientUserAdminNameColumn',
  extends: DataTableRequestColumnVue,
  data: () => ({
    requestClass: UsersRequest,
    defaultPropertyName: 'completeName',
  }),
  computed: {
    proxyRequest() {
      return () => this.requestClass.list({
        page: 1,
        PerPage: 1,
        Search: this.getId,
      });
    },
  },
  methods: {
    prepareDataResponse({ data }) {
      if (Array.isArray(data) && data.length >= 1) {
        return data[0].name;
      }
      return 'Não encontrado';
    },
  },
};
</script>
